export enum FootnotePlaceholder {
    HEADLINE_BANDWIDTH = '$bandwidth',
    HEADLINE_REGIO_FEE = '$regioCharge',
    PRODUCT_NAME = '$productName',
    DISCOUNT_TEXT = '$discountDetail',
    DISCOUNT_DURATION = '$discountMonths',
    DISCOUNT_PRICE = '$discountPrice',
    FINAL_PRICE = '$finalPrice',
    REGIO_FEE_TEXT = '$regioFeeDetail',
    REGIO_FEE_PRICE = '$regioFeePrice',
    PRODUCT_DEVICES = '$productDevices',
    WECHSEL_SECTION = '$wechselgarantieDetail',
    DISCOUNT_DURATION_END = '$stairwayEndMonth',
    AVAILABLE_TARIFFS = '$availibleTariffs',
    NEW_CONTRACT_PERIOD = '$monthOfTerms',
}

export enum ProductPlaceholder {
    PRODUCT = '$product',
    DOWNLOAD = '$download',
    UPLOAD = '$upload',
    MONTH = '$month',
    PRICE = '$price',
    DISCOUNT = '$discount',
    DURATION = '$duration',
    PROVISION_FEE = '$provisionFee',
    INSTALLATION_FEE = '$installationFee'
}
